import Base from './condition-base'
import renderFields from './step-count-exceed.pug'

export default class StepCountExceed extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  @DEFAULTS:
    count: 0

  renderFields: renderFields
